import React from 'react'
import { useHistory } from 'react-router-dom'

import TestimonialsLegacy from 'components/Admin/TestimonialsLegacy'
import auth from 'auth'
import useAxios from 'hooks/useAxios'
import PageHeaderContainer from 'shared/components/PageHeader/container'
import { hasPermission } from 'components/HasPermission'
import constants from 'config/constants'

function TestimonialsPage() {
  const history = useHistory()
  const { data: user } = useAxios({
    url: 'account/users/me/v2/',
  })

  const canViewTestimonialPage = hasPermission(constants.permissions.canViewTestimonialPage, user)
  if (user.permissions && !canViewTestimonialPage) {
    _redirectToHome()
  }

  function _redirectToHome() {
    history.push({
      pathname: '/',
      state: {
        error: constants.permissionDeniedErrorMessage,
      },
    })
  }

  const companyId = auth.getUserInfoFromToken().company.id

  function encodeCompanyKey(companyID) {
    return btoa(companyID)
  }

  const companyKey = encodeCompanyKey(companyId)
  return (
    <React.Fragment>
      <PageHeaderContainer title="Testimonials" />
      <TestimonialsLegacy companyKey={companyKey} />
    </React.Fragment>
  )
}

export default TestimonialsPage



// WEBPACK FOOTER //
// ./node_modules/eslint-loader??ref--0-0!./src/pages/Admin/Testimonials/index.js